module.exports = __webpack_public_path__ + "img/c02_buildingstartechsaddlebags_Normal_ua.eb2c682b.webp";